<script lang="ts">
  let {
    value = 0,
    size = 'thin',
    variant = 'accent',
    indeterminate = false,
    valueText,
    label,
    class: className = ''
  }: {
    value?: number;
    size?: 'thin' | 'md' | 'lg';
    variant?: 'accent' | 'success' | 'warning' | 'danger';
    indeterminate?: boolean;
    valueText?: string;
    label?: string;
    class?: string;
  } = $props();

  const clamped = $derived(Math.max(0, Math.min(100, value)));
  const fraction = $derived(clamped / 100);
</script>

<div
  class="track {className}"
  data-size={size}
  data-variant={variant}
  data-indeterminate={indeterminate || undefined}
  role="progressbar"
  aria-valuemin="0"
  aria-valuemax="100"
  aria-valuenow={indeterminate ? undefined : clamped}
  aria-valuetext={valueText}
  aria-label={label}
>
  <div class="fill" style="transform: scaleX({indeterminate ? 0.3 : fraction});"></div>
</div>

<style>
  .track {
    position: relative;
    width: 100%;
    background: var(--color-surface-sunken);
    border: var(--border-width) solid var(--color-border);
    border-radius: var(--radius-sm);
    overflow: hidden;
  }

  .track[data-size='thin'] { height: 6px; }
  .track[data-size='md'] { height: 8px; }
  .track[data-size='lg'] { height: 12px; }

  .fill {
    height: 100%;
    width: 100%;
    transform-origin: left center;
    background: var(--color-accent);
    border-radius: inherit;
    transition: transform var(--dur-base) var(--ease-out);
  }

  .track[data-variant='success'] .fill { background: var(--color-success); }
  .track[data-variant='warning'] .fill { background: var(--color-warning); }
  .track[data-variant='danger'] .fill { background: var(--color-danger); }

  .track[data-indeterminate] .fill {
    animation: progress-indeterminate 1.4s ease-in-out infinite;
  }

  @keyframes progress-indeterminate {
    0% { transform: translateX(-100%) scaleX(0.3); }
    50% { transform: translateX(30%) scaleX(0.4); }
    100% { transform: translateX(100%) scaleX(0.3); }
  }
</style>